import { jsx as e } from "react/jsx-runtime";
import { forwardRef as r } from "react";
import m from "@mui/material/List";
import a from "styled-components";
const R = {
  root: "listRoot"
}, n = a(m).withConfig({
  displayName: "StyledList"
})([
  "&&.listRoot{background-color:",
  ";overflow:auto;}&&.listRoot .listItemRoot + .listItemRoot,&&.listRoot .listItemRoot + .listItemButtonRoot,&&.listRoot .listItemButtonRoot + .listItemRoot,&&.listRoot .listItemButtonRoot + .listItemButtonRoot{margin-top:1px;}"
], ({ theme: t }) => t.primaryBackground), u = /* @__PURE__ */ r(({ children: t, classes: o, dense: s = !0, ...i }, l) => /* @__PURE__ */ e(n, {
  ...i,
  ref: l,
  dense: s,
  classes: {
    ...R,
    ...o
  },
  children: t
}));
u.displayName = "List";
export {
  u as default
};
